<template>
  <div class="side-bar__menu-submenu-item">
    <template v-if="checkVisibleItem">
      <template v-if="item.hasChild">
        <div class="side-bar__menu-submenu-item-name accordItemTitlesJs"
             v-bind:class="{'router-link-active open' : checkActiveSubRoute(item.child)}">
          {{ getItemTitle(item) }}
        </div>
        <div class="side-bar__menu-mod-submenu"
             v-bind:class="{'open' : checkActiveSubRoute(item.child)}">
          <template v-for="(itemChild, index) in item.child">
            <router-link
                v-if="checkVisibleItemSubmenu(itemChild)"
                :key="index"
                v-bind:class="{'router-link-active' : checkActiveSubRouteItem(itemChild)}"
                :to="itemChild.linkPath" class="side-bar__menu-mod-submenu-item">
              {{ getChildItemTitle(itemChild) }}
            </router-link>
          </template>
        </div>
      </template>

      <template v-else>
        <router-link
                v-if="!Object.hasOwnProperty.call(item, 'linkFunc')"
                :to="item.linkPath"
                v-bind:class="{'router-link-active' : checkActiveRoute(item.linkPath)}"
                class="side-bar__menu-submenu-item-name">
          <template v-if="_.has(item, 'count')">
            <span class="side-bar__menu-item-count-wrap">
              <span class="side-bar__menu-item-count-wrap-text">
                 {{ getItemTitle(item) }}
              </span>


              <span class="side-bar__menu-item-count" v-if="item.count <= 99">
                {{item.count}}
              </span>
              <span class="side-bar__menu-item-count" v-else>
                +99
              </span>
            </span>
          </template>

          <template v-else>
            {{ getItemTitle(item) }}
          </template>


        </router-link>
        <div v-else
             class="side-bar__menu-submenu-item-name"
             v-bind:class="{'router-link-active' : checkActiveRoute(item.linkPath)}"
             @click="$emit(item.linkFunc)"
        >
         {{ getItemTitle(item) }}
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {munuFunc} from "@/mixins/menuMixins/menuFunc";

  export default {
    name: "MenuItem",

    mixins: [munuFunc],

    props: {
      item: Object,
      groupKey: {
        type: String,
        default: '',
      },
    },

    computed: {
      checkVisibleItem() {
        if(!this.checkVisibleMenuItem(this.item)) return false
        if(this.isMenuLinkHidden(this.groupKey, this.item.translation)) return false

        return true
      }
    },

    methods: {

      getItemTitle(item) {
        if(this.getCurrentImpersonateUser && localStorage.getItem('parentUserId') && this.getMenuLinkOwnTranslation(this.groupKey, item.translation)) {
          return `${this.$t(`${item.translation}.localization_value.value`)} (${this.getMenuLinkOwnTranslation(this.groupKey, item.translation)})`
        }
        return this.getMenuLinkOwnTranslation(this.groupKey, item.translation) ||
            this.$t(`${item.translation}.localization_value.value`)
      },

      getChildItemTitle(itemChild) {
        if(this.getCurrentImpersonateUser && localStorage.getItem('parentUserId')) {
          return `${this.$t(`${itemChild.translation}.localization_value.value`)} (${this.getMenuLinkOwnTranslation(this.groupKey, itemChild.translation, this.item.translation)})`
        }

        return this.getMenuLinkOwnTranslation(this.groupKey, itemChild.translation, this.item.translation) ||
            this.$t(`${itemChild.translation}.localization_value.value`)
      },

      checkVisibleItemSubmenu(itemChild) {
        if(!this.checkVisibleMenuSubItem(itemChild)) return false
        if(this.isMenuLinkHidden(this.groupKey, itemChild.translation, this.item.translation)) return false

        return true
      },

      checkActiveRoute(path) {
        return this.$route.path.indexOf(path) > -1
      },

      /**
       * If need active menu item other page with other route path
       */
      checkActiveSubRoute(child) {
        let flag = false
        child.map(item => {
          if (this.$route.path.indexOf(item.linkPath) > -1)
            flag = true

          if(item.linkOtherPath && this.$route.path.indexOf(item.linkOtherPath) > -1){
            flag = true
          }
        })
        return flag
      },

      checkActiveSubRouteItem(item) {
        return item.linkOtherPath && this.$route.path.indexOf(item.linkOtherPath) > -1
      },

    },

  }
</script>

<style scoped>

</style>
